module.exports = __webpack_public_path__ + "img/icon-chat-lock.74fc8616.svg";